module.exports = __webpack_public_path__ + "img/originalrpg.a86b4e1a.jpg";